export default "__VITE_ASSET__BD76YZKi__"